import React from "react";
import { GeolocationProvider } from "../src/utils/localization/geolocation/GeolocationContext";
import smoothscroll from "smooth-scroll";
import { getCurrentGeolocation } from "../src/utils/localization/geolocation/geolocationLoader";
import { GatsbyBrowser } from "gatsby";

// used to fix ios 100vh when toolbar is shown
function computeReal100vh() {
  document
    .querySelector<HTMLElement>(":root")
    ?.style?.setProperty("--vh", window.innerHeight / 100 + "px");
}

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  getCurrentGeolocation();

  window.addEventListener("resize", () => {
    computeReal100vh();
  });
  computeReal100vh();

  window.smoothscroll = smoothscroll; // IMPORTANT!
  smoothscroll('a[href*="#"]', {
    offset: function () {
      const isAEMMobileMenu = window.matchMedia("(max-width: 991px)").matches;
      return isAEMMobileMenu ? 60 : 110;
    }
  });
};

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element
}) => <GeolocationProvider>{element}</GeolocationProvider>;
